import React from "react";
import Partners from "../modules/Partners/Partners";

export default function PartnersPage() {
  return <Partners />;
}
